module.exports = __webpack_public_path__ + "media/review-badges/rank-5k-9eef6cff.svg";